import {
    KYC_MAX_CARDS,
    KYC_MAX_PURCHASE_AMOUNT,
    MAX_CARDS,
    MAX_PURCHASE_AMOUNT,
} from '@/src/modules/checkout/strings'
import { TKYCMinMaxValidations } from '@/src/modules/build-a-card/types'

type TKYCMinMaxProps = {
    isEditing: boolean
    totalValueLoadInCart: number
    totalNumberOfCardsInCart: number
    newGiftTotalDenom: number
    itemDenomFromCart: number
    newCardQuantity: number
    // this is used exclusively for box because the user
    // is editing more than one card at a time
    originalCardQuantity?: number
}

function checkKYCMinMaxLimits({
    isEditing,
    totalValueLoadInCart,
    totalNumberOfCardsInCart,
    newGiftTotalDenom,
    itemDenomFromCart,
    newCardQuantity,
    originalCardQuantity = 1,
}: TKYCMinMaxProps) {
    const numberOfCards: number = isEditing
        ? totalNumberOfCardsInCart -
          originalCardQuantity +
          Number(newCardQuantity)
        : totalNumberOfCardsInCart + Number(newCardQuantity)

    const totalCardLoad: number =
        totalValueLoadInCart - itemDenomFromCart + newGiftTotalDenom

    let limitData: TKYCMinMaxValidations = {
        loadAmountMeetsKYCMin: totalCardLoad > MAX_PURCHASE_AMOUNT,
        numberOfCardsMeetsKYCMin: numberOfCards > MAX_CARDS,
        loadAmountExceedsKYCMax: totalCardLoad > KYC_MAX_PURCHASE_AMOUNT,
        numberOfCardsExceedsKYCMax: numberOfCards > KYC_MAX_CARDS,
    }

    return limitData
}

export default checkKYCMinMaxLimits
